import { BookOpen, Download, FileText } from "lucide-react";

export const DataExportsCard = ({
  exporting,
  showMethodology,
  methodology,
  onExportCsv,
  onViewMethodology,
  onDownloadMethodology,
}) => (
  <div
    data-testid="data-exports-card"
    className="mt-10 rounded-xl border border-slate-200 bg-white p-6 lg:p-8"
  >
    <div className="flex flex-wrap items-start gap-6 justify-between">
      <div className="max-w-2xl">
        <h2 className="font-display text-2xl font-bold text-slate-900">
          Data exports &amp; methodology
        </h2>
        <p className="mt-2 text-sm text-slate-600">
          Download the live roles dataset as a CSV — one row per role with
          mandatory / important technical &amp; soft skills and the current
          demand level. Edit in Excel or Google Sheets, then upload the file
          back via <b>Upload roles CSV</b> above.
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          data-testid="export-roles-csv-btn"
          onClick={onExportCsv}
          disabled={exporting}
          className="inline-flex items-center gap-2 rounded-md bg-slate-900 text-white px-4 py-2.5 text-sm font-semibold hover:bg-slate-800 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <Download size={14} />
          {exporting ? "Preparing…" : "Download roles CSV"}
        </button>
        <button
          type="button"
          data-testid="view-methodology-btn"
          onClick={onViewMethodology}
          className="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white text-slate-800 px-4 py-2.5 text-sm font-semibold hover:bg-slate-50"
        >
          <BookOpen size={14} />
          {showMethodology ? "Hide methodology" : "View methodology"}
        </button>
        <button
          type="button"
          data-testid="download-methodology-btn"
          onClick={onDownloadMethodology}
          className="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white text-slate-800 px-4 py-2.5 text-sm font-semibold hover:bg-slate-50"
        >
          <FileText size={14} />
          Download methodology
        </button>
      </div>
    </div>

    <div className="mt-5 grid sm:grid-cols-3 gap-2 text-xs text-slate-600">
      <div className="rounded-md bg-slate-50 border border-slate-200 px-3 py-2.5">
        <p className="font-semibold text-slate-900">CSV columns</p>
        <p className="mt-1 leading-relaxed">
          role_id · role_name · category · mandatory_technical_skills ·
          important_technical_skills · mandatory_soft_skills ·
          important_soft_skills · demand_level · demand_score
        </p>
      </div>
      <div className="rounded-md bg-slate-50 border border-slate-200 px-3 py-2.5">
        <p className="font-semibold text-slate-900">Skill cell format</p>
        <p className="mt-1 leading-relaxed">
          Each cell is a semicolon-separated list (e.g.
          <code className="px-1">SQL; Python; Tableau</code>) so commas
          don&apos;t break CSV parsing.
        </p>
      </div>
      <div className="rounded-md bg-slate-50 border border-slate-200 px-3 py-2.5">
        <p className="font-semibold text-slate-900">Editing roundtrip</p>
        <p className="mt-1 leading-relaxed">
          Download → edit in Excel/Sheets → upload back via{" "}
          <b>Upload roles CSV</b>. The cache is persisted, so server restarts
          won&apos;t lose your import.
        </p>
      </div>
    </div>

    {showMethodology && methodology && (
      <div
        data-testid="methodology-preview"
        className="mt-6 rounded-lg border border-slate-200 bg-slate-50 p-5 max-h-[480px] overflow-y-auto"
      >
        <pre className="whitespace-pre-wrap font-mono text-[12px] leading-relaxed text-slate-800">
          {methodology}
        </pre>
      </div>
    )}
  </div>
);

export default DataExportsCard;
